export default {
  FORBID_ATTR: ['data-target'],
}
